import { useState } from 'react';
import { Table } from '@humanforce/mango-ui-react';
import type { OrgData } from '../organisationFixtures';

interface ComplianceTabProps {
  orgId: string;
  orgData: OrgData;
}

interface ComplianceRow {
  name: string;
  country: string;
  regionalTax: string;
  stpPhase: string;
  lastSubmission: string;
}

const columns = [
  { field: 'name', header: 'Business record name', sortable: true },
  { field: 'country', header: 'Country', sortable: true },
  { field: 'regionalTax', header: 'Regional tax', sortable: true },
  { field: 'stpPhase', header: 'STP phase', sortable: true },
  { field: 'lastSubmission', header: 'Last submission', sortable: true },
];

export const ComplianceTab = ({ orgData }: ComplianceTabProps) => {
  const [selected, setSelected] = useState<ComplianceRow[]>([]);

  const rows: ComplianceRow[] = orgData.businessRecords.map((br) => ({
    name: br.name,
    country: br.legal.country,
    regionalTax: br.legal.regionalTax ? 'Yes' : 'No',
    stpPhase: String(br.stp.phase ?? ''),
    lastSubmission: String(br.stp.lastSubmission ?? ''),
  }));

  return (
    <div className="mgo-stack mgo-gap-l">
      <Table
        value={rows}
        columns={columns}
        selectable
        selection={selected}
        onSelectionChange={(sel) => setSelected(Array.isArray(sel) ? sel as ComplianceRow[] : [sel as ComplianceRow])}
      />
    </div>
  );
};
